type TabValue = "patterns" | "doji" | "structure" | "reversal" | "divergences" | "trend";

const TAB_LABELS: Record<TabValue, string> = {
  patterns: "Candlestick Patterns",
  doji: "Doji",
  structure: "Daily Structure",
  reversal: "Reversal Analysis",
  divergences: "Divergences",
  trend: "Trend Filter",
};

interface DataTabsTabBarProps {
  activeTab: TabValue;
  onTabChange: (tab: TabValue) => void;
  counts: Record<TabValue, number | string>;
}

export default function DataTabsTabBar({ activeTab, onTabChange, counts }: DataTabsTabBarProps) {
  return (
    <div style={{ display: "flex", gap: "0.5rem", marginBottom: "2rem", borderBottom: "2px solid rgba(148, 163, 184, 0.2)", flexWrap: "wrap" }}>
      {(["patterns", "doji", "structure", "reversal", "divergences", "trend"] as const).map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          style={{
            padding: "1rem 1.5rem",
            background: "transparent",
            border: "none",
            borderBottom: activeTab === tab ? "3px solid var(--blue-text)" : "3px solid transparent",
            color: activeTab === tab ? "var(--blue-text)" : "rgba(241, 245, 249, 0.6)",
            fontSize: "1rem",
            fontWeight: activeTab === tab ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => { if (activeTab !== tab) e.currentTarget.style.color = "rgba(241, 245, 249, 0.9)"; }}
          onMouseLeave={(e) => { if (activeTab !== tab) e.currentTarget.style.color = "rgba(241, 245, 249, 0.6)"; }}
        >
          {TAB_LABELS[tab]} ({counts[tab]})
        </button>
      ))}
    </div>
  );
}
